import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Copy, QrCode, LogIn } from "lucide-react";
import { toast } from "sonner";
import { QRCodeSVG } from "qrcode.react";

import { Navbar } from "@/components/layout/Nav";
import { useLang } from "@/context/LangContext";
import { api } from "@/api/client";
import { Carlos } from "@/components/characters/Characters";

export default function ExamsInfo() {
  const { t, lang } = useLang();
  const [exams, setExams] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        // Try admin list first (if the visitor is admin); fall back to nothing.
        const { data } = await api.get("/admin/exams");
        setExams(data);
      } catch {
        setExams([]);
      }
    })();
  }, []);

  const publicUrl = (slug) => `${window.location.origin}/exam/${slug}`;
  const copy = async (slug) => {
    await navigator.clipboard.writeText(publicUrl(slug));
    toast.success(t("linkCopied"));
  };

  return (
    <div className="min-h-screen bg-halftone">
      <Navbar />
      <div className="max-w-5xl mx-auto px-4 py-10">
        <div className="brutal p-8 bg-canales-yellow flex items-center gap-4">
          <Carlos size={90} waving />
          <div>
            <h1 className="font-display font-black text-3xl sm:text-4xl">{t("exams")}</h1>
            <p className="font-body mt-1">
              {lang === "es"
                ? "El admin crea exámenes y comparte un link único con cada empleado."
                : "Admin creates exams and shares a unique link with each employee."}
            </p>
          </div>
        </div>

        {exams.length === 0 ? (
          <div className="mt-8 brutal p-6 text-center">
            <p className="font-body text-lg">
              {lang === "es"
                ? "Solo el Admin puede ver y crear exámenes. Inicia sesión para gestionarlos."
                : "Only Admins can see and create exams. Sign in to manage them."}
            </p>
            <Link
              to="/"
              className="mt-4 inline-flex items-center gap-2 brutal-btn bg-canales-blue text-white px-4 py-2"
            >
              <LogIn className="w-4 h-4" /> {lang === "es" ? "Volver al inicio" : "Back home"}
            </Link>
          </div>
        ) : (
          <div className="mt-8 grid md:grid-cols-2 gap-4">
            {exams.map((e) => (
              <div key={e.exam_id} className="brutal p-5 bg-white">
                <div className="flex items-center justify-between">
                  <div>
                    <div className="text-xs font-display font-bold uppercase tracking-widest text-canales-red">
                      {e.category}
                    </div>
                    <h3 className="font-display font-black text-xl">{lang === "es" ? e.title_es : e.title_en}</h3>
                  </div>
                  <QRCodeSVG value={publicUrl(e.slug)} size={72} bgColor="#fff8e7" fgColor="#0B0B14" />
                </div>
                <div className="mt-3 text-sm font-body break-all">
                  <a href={publicUrl(e.slug)} className="text-canales-blue underline">
                    {publicUrl(e.slug)}
                  </a>
                </div>
                <button
                  onClick={() => copy(e.slug)}
                  className="mt-3 brutal-btn bg-canales-yellow px-3 py-1 text-sm flex items-center gap-2"
                >
                  <Copy className="w-4 h-4" /> {t("copyLink")}
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
